import { Button, Input, InputNumber } from "antd";

// 加分项接口定义
export interface plusScoreItem {
  // 评分项内容
  content: string;
  // 创建时间
  createTime: string;
  // 表单ID
  formId: number;
  // 完整内容
  fullContent: string;
  // 评分项ID
  id: number;
  // 条目ID
  itemId: number;
  // 分值
  scoreValue: number;
  // 分值文本
  scoreValueText: string;
  // 显示顺序
  showOrder: number;
  // 更新时间
  updateTime: string;
  // 当前分值
  value?: number;
  // 题目配置的最高分（暂存后 scoreValue 可能是当前分值）
  maxScoreValue?: number;
  userScore?: number;
  expertScore?: number;
  score?: number;
  scoreText?: string;
  scoreCompute?: number;
  scoreComputeText?: string;
  expertScoreValue?: number;
  expertScoreValueText?: string;
}

// 减分项接口定义
export interface minusScoreItem {
  // 评分项内容
  content: string;
  // 创建时间
  createTime: string;
  // 表单ID
  formId: number;
  // 完整内容
  fullContent: string;
  // 评分项ID
  id: number;
  // 条目ID
  itemId: number;
  // 分值
  scoreValue: number;
  // 分值文本
  scoreValueText: string;
  // 显示顺序
  showOrder: number;
  // 更新时间
  updateTime: string;
  // 当前分值
  value?: number;
  // 题目配置的最高分（暂存后 scoreValue 可能是当前分值）
  maxScoreValue?: number;
  score?: number;
  scoreText?: string;
  scoreCompute?: number;
  scoreComputeText?: string;
}

// 加分项组件属性类型
type plusPropsType = {
  // 基础信息
  baseInfo: plusScoreItem;
  disabled?: boolean;
  showScoreResult?: boolean;
  // 列表索引
  listIndex: number;
  // 条目索引
  itemIndex: number;
  // 分值变更回调
  onChangeValue(list: number, item: number, type: number, value?: number): void;
};

// 减分项组件属性类型
type minusPropsType = {
  // 基础信息
  baseInfo: minusScoreItem;
  disabled?: boolean;
  // 列表索引
  listIndex: number;
  // 条目索引
  itemIndex: number;
  // 分值变更回调
  onChangeValue(list: number, item: number, type: number, value?: number): void;
};

export const PlusEvaluateItem: React.FC<plusPropsType> = (props) => {
  const {
    baseInfo,
    disabled,
    showScoreResult,
    listIndex,
    itemIndex,
    onChangeValue,
  } = props;
  return (
    <li>
      <p className="comment_rateview_i_subtitle">{baseInfo.fullContent}</p>
      <div className="comment_rateview_i_text">
        <Input.Group>
          <Button
            disabled={disabled}
            onClick={() => {
              onChangeValue(listIndex, itemIndex, 0);
            }}
          >
            满分
          </Button>
          <Button
            disabled={disabled}
            onClick={() => {
              onChangeValue(listIndex, itemIndex, 1);
            }}
          >
            +
          </Button>
          <InputNumber
            style={{ width: 80 }}
            max={baseInfo.maxScoreValue}
            value={baseInfo.value}
            disabled={disabled}
            onChange={(value) => {
              onChangeValue(listIndex, itemIndex, 4, value as any);
            }}
          />
          <Button
            disabled={disabled}
            onClick={() => {
              onChangeValue(listIndex, itemIndex, 2);
            }}
          >
            -
          </Button>
          <Button
            disabled={disabled}
            onClick={() => {
              onChangeValue(listIndex, itemIndex, 3);
            }}
          >
            零分
          </Button>
        </Input.Group>
      </div>
      {showScoreResult && (
        <p className="comment_rateview_i_score_result">
          <span>学员评分：{baseInfo.scoreText ?? baseInfo.score ?? baseInfo.value}</span>
          {baseInfo.expertScoreValue !== undefined && (
            <span>专家评分：{baseInfo.expertScoreValueText ?? baseInfo.expertScoreValue}</span>
          )}
          {(baseInfo.scoreCompute !== undefined || baseInfo.scoreComputeText) && (
            <span>得分：{baseInfo.scoreComputeText ?? baseInfo.scoreCompute}</span>
          )}
        </p>
      )}
    </li>
  );
};

export const MinusEvaluateItem: React.FC<minusPropsType> = (props) => {
  const { baseInfo, disabled, listIndex, itemIndex, onChangeValue } = props;
  return (
    <li>
      <p className="comment_rateview_i_subtitle">{baseInfo.fullContent}</p>
      <div className="comment_rateview_i_text">
        <Input.Group>
          <Button
            disabled={disabled}
            onClick={() => {
              onChangeValue(listIndex, itemIndex, 0);
            }}
          >
            全部扣除
          </Button>
          <Button
            disabled={disabled}
            onClick={() => {
              onChangeValue(listIndex, itemIndex, 1);
            }}
          >
            +
          </Button>
          <InputNumber
            style={{ width: 80 }}
            max={baseInfo.maxScoreValue}
            value={baseInfo.value}
            disabled={disabled}
            onChange={(value) => {
              onChangeValue(listIndex, itemIndex, 4, value as any);
            }}
          />
          <Button
            disabled={disabled}
            onClick={() => {
              onChangeValue(listIndex, itemIndex, 2);
            }}
          >
            -
          </Button>
        </Input.Group>
      </div>
    </li>
  );
};
